import {TaskField} from '../../../../../../../constants/tasks';
import {CurrentTaskAnswer, FormattedFormField, QuestionDetails} from '../../../../../types';

type InitialValuesParams = {
  id: number,
  type: TaskField,
  details: Nullable<QuestionDetails>,
  answers: CurrentTaskAnswer[]
}

const getInitialValueByType = ({
  id,
  type,
  details,
  answers
}: InitialValuesParams) => {
  const {answer} = answers?.find(({formFieldId}) => id === formFieldId) ||
    {answer: null};

  const isMultiSelectField = type === TaskField.MULTI_SELECT;

  if (!answer) {
    const {default: initialValue} = details || {};

    if (initialValue) {
      return initialValue;
    }

    return isMultiSelectField ? [] : '';
  }

  if (!isMultiSelectField) {
    return answer;
  }

  return answer?.split(',') || [];
};

export const getInitialValues = (
    questions: FormattedFormField[] = [],
    answers: CurrentTaskAnswer[]
) => {
  return questions.reduce((acc, {id, type, details}) => {
    acc[id] = getInitialValueByType({id, type, details, answers});

    return acc;
  }, {});
};
